"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _time = require('shared/services/time');



// The server never moves a seen time back (MarkBlobjectSeen keeps the later
// one), so neither does the store. Opening a chat marks it seen at once, while
// the deep load sent on open can be read before the mark lands; its reply, or
// any other row fetched or pushed meanwhile, carries the old seen time and
// would turn the row unread until the mark's own update came in.
 const laterSeenTime = (current, incoming) =>
  current && (!incoming || _time.isLaterTime.call(void 0, String(current), String(incoming))) ? current : incoming; exports.laterSeenTime = laterSeenTime

// The same goes for my "marked unread" flag: marking and opening change it
// here first. The server moves my UpdatedAt with every change to the flag, so
// a row whose UpdatedAt is no later than the store's predates that change and
// keeps the store's flag, and the store's UpdatedAt with it: taking the
// row's older one would let a later stale row through.
const isStaleMetadata = (current, incoming) =>
  !!_optionalChain([current, 'optionalAccess', _ => _.UpdatedAt]) && !!incoming.UpdatedAt && !_time.isLaterTime.call(void 0, String(incoming.UpdatedAt), String(current.UpdatedAt))

// The incoming row, keeping whichever of my seen time, mark and pin the
// current row has newer. Returns incoming itself when nothing is kept.
 const withFresherMyMetadata = (
  current, incoming, myUserKey,
) => {
  const currentMeta = _optionalChain([current, 'optionalAccess', _2 => _2.UserMetadata, 'optionalAccess', _3 => _3[myUserKey]]) 
  const mine = _optionalChain([incoming, 'optionalAccess', _4 => _4.UserMetadata, 'optionalAccess', _5 => _5[myUserKey]]) 
  if (!currentMeta || !mine) return incoming
  const currentSeen = currentMeta.SeenTime
  const keepSeenTime = !!currentSeen && exports.laterSeenTime.call(void 0, currentSeen, mine.SeenTime) !== mine.SeenTime
  const isStale = isStaleMetadata(currentMeta, mine)
  const keepMark = isStale && !!currentMeta.MarkedUnread !== !!mine.MarkedUnread
  // Pinning moves UpdatedAt too, so the same rule keeps a fresh pin.
  const keepPin = isStale && (currentMeta.PinnedAt || null) !== (mine.PinnedAt || null)
  const keepUpdatedAt = isStale && currentMeta.UpdatedAt !== mine.UpdatedAt
  if (!keepSeenTime && !keepMark && !keepPin && !keepUpdatedAt) return incoming
  return {
    ...incoming,
    UserMetadata: {
      ...incoming.UserMetadata,
      [myUserKey]: {
        ...mine,
        ...(keepSeenTime && { SeenTime: currentSeen }),
        ...(keepMark && { MarkedUnread: currentMeta.MarkedUnread }),
        ...(keepPin && { PinnedAt: currentMeta.PinnedAt }),
        ...(keepUpdatedAt && { UpdatedAt: currentMeta.UpdatedAt }),
      },
    },
  }
}; exports.withFresherMyMetadata = withFresherMyMetadata
